import { createSelector } from 'reselect'
import { EmptyArray } from "../../../Resources/EmptyDefaults"
import { getEntities } from '../../../Resources/EntityData'
import reducerRegistry from './ReducerRegistry'
import { normalize } from 'normalizr';
import { batch } from 'react-redux'
import { pick } from 'lodash-es'
import deepMerge from 'deepmerge'
import { INVALIDATE_ACTION, ENTITIES_NAMESPACE, DATA_FETCHED } from './DataConstants'
import { isPresent } from 'utils/isPresent';

export { isEntityPresentSelector } from './DataFetcherEntitiesHelperTS';

export function handleEntities(schema, data, dispatch, state, schemaKey) {

  if (isPresent(schemaKey)) {
    if (Array.isArray(data)) {
      data = { id: schemaKey, data: data }
    } else {
      data.id = schemaKey
    }
  }

  const normalizedData = normalize(data, schema)
  const entities = normalizedData.entities

  const keys = Object.keys(entities)

  batch(() => {
    keys.forEach(key => dispatch(addOrUpdateEntities(key, entities[key])))
  })
}

export function addOrUpdateEntities(key, data) {
  const namespace = `${ENTITIES_NAMESPACE}_${key}`
  if (reducerRegistry.isEntityReducerPresent(key) === false) {
    reducerRegistry.registerEntityReducer(key, createEntityReducer({}, key))
  }
  return {
    type: `${DATA_FETCHED}_${namespace}`,
    data: data
  }
}

export function invalidateEntities(key, id) {
  if (reducerRegistry.isEntityReducerPresent(key) === false) {
    reducerRegistry.registerEntityReducer(key, createEntityReducer({}, key))
  }

  return {
    type: `${INVALIDATE_ACTION}_${ENTITIES_NAMESPACE}_${key}`,
    id,
  }
}


export const createEntityReducer = (data, key) => (state = data, action) => {
  const namespace = `${ENTITIES_NAMESPACE}_${key}`

  switch (action.type) {
    case `${DATA_FETCHED}_${namespace}`:
      return {
        ...state,
        ...action.data
      }
    case `${INVALIDATE_ACTION}_${ENTITIES_NAMESPACE}_${key}`:
      return Object.entries(state)
        .filter(([entityKey]) => !entityKey.includes(`id=${action.id}`))
        .reduce((accumulator, [entityKey, entityValue]) => ({ ...accumulator, [entityKey]: entityValue }), {})
    default:
      return state
  }
}

export function updateEntity(key, updatedFields, schemaName) {
  return (dispatch, getState) => {
    const entities = getState().entities || {}
    const allObjects = entities[schemaName] || {}
    const foundEntity = allObjects[key] || {}

    let updatedFoundEntity = Object.assign(foundEntity, updatedFields)
    let copiedEntity = Object.assign({}, updatedFoundEntity)

    dispatch(addOrUpdateEntities(schemaName, { [key]: copiedEntity }))
  }
}

export function updateEntityData(key, updatedFields, schemaName) {
  return (dispatch, getState) => {
    const entities = getState().entities || {}
    const allObjects = entities[schemaName] || {}
    const foundEntity = allObjects[key]

    let updatedFoundEntity = Object.assign({}, foundEntity)
    if (Array.isArray(updatedFoundEntity.data)) {
      updatedFoundEntity.data = [...updatedFoundEntity.data, ...updatedFields]
    } else {
      updatedFoundEntity.data = { ...updatedFoundEntity.data, ...updatedFields }
    }
    let copiedEntity = Object.assign({}, updatedFoundEntity)

    dispatch(addOrUpdateEntities(schemaName, { [key]: copiedEntity }))
  }
}

export function addOrUpdateData(schema, data, mergeArray = true) {
  return (dispatch, getState) => {
    const newEntities = normalize(data, schema).entities

    batch(() => {
      Object.keys(newEntities).forEach(key => {
        const existingEntities = getState()[ENTITIES_NAMESPACE] || {}
        const existingEntityBranch = existingEntities[key] || {}
        const existingEntitiesToMerge = pick(existingEntityBranch, Object.keys(newEntities[key]))
        const mergeOption = mergeArray ? combineMerge : overwriteMerge
        const newAndModifiedEntities = deepMerge(existingEntitiesToMerge, newEntities[key], { arrayMerge: mergeOption })
        dispatch(addOrUpdateEntities(key, newAndModifiedEntities))
      })
    })
  }
}

export function removeListEntityData(itemId, key, namespace) {
  return (dispatch, getState) => {
    const listData = getListEntityData(key, namespace)(getState())
    const filteredData = listData.filter((id) => id !== itemId)
    dispatch(updateEntity(key, { data: filteredData }, namespace))
  }
}

export function addToListEntity(itemId, key, namespace) {
  return (dispatch, getState) => {
    const listData = getListEntityData(key, namespace)(getState())
    dispatch(updateEntity(key, { data: [...new Set([...listData, ...[itemId]])] }, namespace))
  }
}

export function addToLastEntityPage(itemId, namespace) {
  return (dispatch, getState) => {
    const lastPageKey = getLastEntityPage(namespace)(getState())
    dispatch(addToListEntity(itemId, lastPageKey, namespace))
  }
}

export const getLastEntityPage = (namespace) => createSelector(
  getEntities,
  entities => {
    const lastPageKey = Object.keys(entities[namespace] || {}).pop();
    if (lastPageKey) return lastPageKey;

    return null
  }
)

export const getListEntityData = (key, namespace) => createSelector(
  getEntities,
  entities => {
    if (isPresent(entities) && isPresent(entities[namespace])) {
      return entities[namespace][key].data
    }
    return EmptyArray
  }
)

export const getFlatListEntityData = (key, namespace) => createSelector(
  getEntities,
  entities => {
    if (isPresent(entities) && isPresent(entities[namespace])) {
      return entities[namespace][key]
    }
    return EmptyArray
  }
)

export const isEntityPresent = (namespace, key) => (dispatch, getState) => {
  return isPresent(getState().entities) && isPresent(getState().entities[namespace]) && isPresent(getState().entities[namespace][key])
}

const combineMerge = (destinationArray, sourceArray, _options) => [...new Set([...destinationArray, ...sourceArray])]
const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray
